export default "__VITE_ASSET__B_Yi0b9g__"